import enviro from 'enviro';
export const SUPER_ADMIN_ROLE_ID = enviro.isProd() ? 153 : 40436;
export const INTEGRATIONS_MANAGEMENT_ROLE_ID = enviro.isProd() ? 333 : 40643;